/*
 * Copyright (c) 2020-2024. World Wide Generation Ltd
 */

import { RouteInterface, RoutesInterface } from '@g17eco/types/routes';
import { portfolioTrackerInitiativeRoutes } from './portfolioTrackerRoutes';

// Do not require initiative
const portfolioTrackerRouteEntry: RouteInterface = {
  id: 'portfolio_tracker_root',
  label: 'Portfolio Tracker',
  tooltip: 'Portfolio Tracker',
  path: '/portfolio-tracker',
  icon: 'fa-folder-open',
  appPermissionId: 'app_portfolio_tracker',
  exact: false,
  auth: true,
};

export const portfolioTrackerMapRoute: RouteInterface = {
  id: 'portfolio_tracker_map',
  label: 'Organisational structure',
  path: `${portfolioTrackerRouteEntry.path}/initiative-structure/:portfolioId?`,
  icon: 'fa-folder-tree',
  tooltip: 'Navigation Tree of the Reporting Level Dashboards',
  appPermissionId: 'app_portfolio_tracker',
  auth: true,
};

export const portfolioTrackerRoutes: RoutesInterface = {
  PORTFOLIO_TRACKER: portfolioTrackerRouteEntry,
  PORTFOLIO_TRACKER_MAP: portfolioTrackerMapRoute,
  ...portfolioTrackerInitiativeRoutes,
};
